import {
  Button,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import moment from "moment";
import React, { useState } from "react";
import DeleteConfirm from "../../adminComponents/DeleteConfirm";
import getClientService from "../../../../services/getClientService";

const columns = [
  //   { id: 'id', label: '' },
  // { id: 'id', label: 'Client id', minWidth: 350, align: 'center' },
  {
    id: "Date",
    label: "Date",
    minWidth: 170,
    format: (value) => value.toLocaleString("en-US"),
    align: "center",
  },
  {
    id: "Name",
    label: "Name",
    minWidth: 170,
    format: (value) => value.toFixed(2),
    align: "center",
  },
  { id: "Email", label: "Email", minWidth: 170, align: "center" },
  {
    id: "Number",
    label: "Number",
    minWidth: 170,
    format: (value) => value.toLocaleString("en-US"),
    align: "center",
  },
  // {
  //     id: 'Status',
  //     label: 'Status',
  //     minWidth: 170,
  //     format: (value) => value.toLocaleString('en-US'),
  //     align: 'center'
  // },
  {
    id: "Action",
    label: "Action",
    minWidth: 200,
    format: (value) => value.toFixed(2),
    align: "center",
  },
];
const List = ({
  client,
  fetchCleint,
  filterVal,
  setFilterVal,
  setSelectedClient,
  setOpenAddDialog,
}) => {
  const [openDelete, setOpenDelete] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});
  const [deleteLoadingId, setDeleteLoadingId] = useState(null);

  const handleClose = () => {
    setOpenDelete(false);
  };
  const handleChangePage = (event, newPage) => {
    setFilterVal({ ...filterVal, pageNumber: newPage });
  };
  const handleDelete = async () => {
    setDeleteLoadingId(selectedRow.id);
    try {
      const list = await getClientService.DeleteClient(selectedRow.id);
      fetchCleint();
      setOpenDelete(false);
    } catch (error) {
      console.error("Error deleting client:", error);
    }
    setDeleteLoadingId(null);
  };
  const handleClickDelete = (row) => {
    setSelectedRow(row);
    setOpenDelete(true);
  };

  const handleClickEdit = (row) => {
    setSelectedClient(row);
    setOpenAddDialog(true);
  };

  return (
    <div className="table_style_main">
      <TableContainer sx={{ minHeight: "62vh", maxHeight: "72vh" }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {client?.map((row) => {
              return (
                <TableRow className="text-center">
                  {/* <TableCell align='center'>{row.id}</TableCell> */}
                  <TableCell align="center">
                    {moment(row.createdAt).format("MMM Do YY")}
                  </TableCell>
                  <TableCell align="center">
                    {row.first_name + " " + row.last_name}
                  </TableCell>
                  <TableCell align="center">{row.email}</TableCell>
                  <TableCell align="center">{row.phone_num}</TableCell>
                  {/* <TableCell align='center'>{row.status}</TableCell> */}
                  <TableCell align="center">
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      onClick={() => handleClickEdit(row)}
                    >
                      Edit
                    </Button>
                    <Button
                      variant="contained"
                      className="ms-2"
                      color="secondary"
                      size="small"
                      onClick={() => handleClickDelete(row)}
                      disabled={deleteLoadingId === row.id}
                    >
                      {deleteLoadingId === row.id ? "Deleting..." : "Delete"}
                    </Button>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <div className="d-flex justify-content-end mt-3 mb-3 px-4">
        <Pagination
          page={filterVal.pageNumber}
          onChange={handleChangePage}
          count={filterVal.totalPages}
          variant="outlined"
          color="primary"
        />
      </div>
      <DeleteConfirm
        openDelete={openDelete}
        handleDelete={handleDelete}
        handleClose={handleClose}
      />
    </div>
  );
};

export default List;
